// stores/contact.ts
import { defineStore, acceptHMRUpdate } from 'pinia';

type ContactState = {
  title: string;
  name: string;
  email: string;
  postcode: string;
};

export const useContactStore = defineStore('ContactStore', {
  state: (): ContactState => ({
    title: '',
    name: '',
    email: '',
    postcode: '',
  }),

  actions: {
    SET_CONTACT(payload: Partial<ContactState>) {
      if (payload.title !== undefined) this.title = payload.title;
      if (payload.name !== undefined) this.name = payload.name;
      if (payload.email !== undefined) this.email = payload.email;
      if (payload.postcode !== undefined) this.postcode = payload.postcode;
    },

    SET_TITLE(v: string) {
      this.title = v;
    },
    SET_NAME(v: string) {
      this.name = v;
    },
    SET_EMAIL(v: string) {
      this.email = v;
    },
    SET_POSTCODE(v: string) {
      this.postcode = v;
    },

    RESET_CONTACT() {
      this.title = '';
      this.name = '';
      this.email = '';
      this.postcode = '';
    },
  },

  getters: {
    getContact: (state) => state,
    getTitle: (state) => state.title,
    getName: (state) => state.name,
    getEmail: (state) => state.email,
    getPostcode: (state) => state.postcode,
    getIsComplete: (state) =>
      !!(
        state.title.trim() &&
        state.name.trim() &&
        state.email.trim() &&
        state.postcode.trim()
      ),
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useContactStore, import.meta.hot));
}
